<template>
<div id="secure">

    <TopMenu />
    <section class="main-content columns is-fullheight">
        <div class="container column is-12">
            <div class="section">
                <a class="button is-info is-outlined" v-on:click="goTutorial()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-youtube-play"></i></span> Tutorial
                </a>
                <a class="button is-info is-outlined" v-on:click="getHelp()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-question-circle"></i></span> Help
                </a>
                <a class="button is-info" href="https://www.studentqr.com/download" target="_blank" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-cloud-download"></i></span> Download App
                </a>
                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Groups<a class="button is-info" style="margin-left: 15px;" v-on:click="goGroupLeaderboard()">Leaderboard</a></p>                        
                        <p class="header-date"> {{ dateDisplay }}</p>
                        <div style="padding: 0px; padding-right: 10px; padding-top: 10px;">
                            <a class="button is-primary is-small" style="margin-left: 5px;" v-on:click="goDbGroup()">Manage Groups</a>
                        </div>
                    </div>
                    <div class="card-content">
                        <loading :active.sync="isLoading" 
                            :can-cancel="false" 
                            :is-full-page="true">
                        </loading>
                        
                        <div class="columns is-multiline">
                            <div class="column is-half" v-for="group in groupList" :key="group._id">
                                <div class="card">
                                    <div class="card-header">
                                        <p class="card-header-title"><a class="button is-info" v-on:click="viewGroupDashboard(group._id,group.name)">{{ group.name}}</a></p><span class="header-tag">{{ group.tempNumber1}} points</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                                       
                    </div>
                </div>
                <br />

            </div>
        </div>

    </section>    
</div>
</template>

<script>
import TopMenu from '../TopMenu'
import axios from 'axios'
import "../public/style.scss";
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';


export default {
    name: "GroupDashboard",
    components: {
        TopMenu,
        Loading,
    },
    data() {
        return {
            isLoading: false,
            isLoading1: false,
            dateDisplay: '',
            actionDate: '',
            actionYear: '',
            groupList: [],
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
        console.log("before mount hoho");
    },
    created() {
        var currentDate = new Date();
        var currentDay = currentDate.getDate();
        if (currentDate.getDate() < 10){
            currentDay = "0" + currentDay;
        }
        this.actionYear = currentDate.getFullYear()
        var currentMonth = currentDate.getMonth() + 1;  //since month starts from 0
        if (currentMonth < 10){
            currentMonth = "0" + currentMonth;
        }
        this.actionDate = this.actionYear + "" + currentMonth + "" + currentDay;
        console.log("actionDate: " + this.actionDate)

        var month = currentDate.getMonth();
        var dayOfWeek = currentDate.getDay();

        var dayOfWeekDisplay = "";
        switch (dayOfWeek){
            case 0:
                dayOfWeekDisplay = "Sunday";
                break;
            case 1:
                dayOfWeekDisplay = "Monday";
                break;
            case 2:
                dayOfWeekDisplay = "Tuesday";
                break;
            case 3:
                dayOfWeekDisplay = "Wednesday";
                break;
            case 4:
                dayOfWeekDisplay = "Thursday";
                break;
            case 5:
                dayOfWeekDisplay = "Friday";
                break;
            case 6:
                dayOfWeekDisplay = "Saturday";
                break;
            default:
                dayOfWeekDisplay = "Monday";
                break;
        }

        var monthDisplay = "";
        switch (month){
            case 0:
                monthDisplay = "January";
                break;
            case 1:
                monthDisplay = "February";
                break;
            case 2:
                monthDisplay = "March";
                break;
            case 3:
                monthDisplay = "April";
                break;
            case 4:
                monthDisplay = "May";
                break;
            case 5:
                monthDisplay = "June";
                break;
            case 6:
                monthDisplay = "July";
                break;
            case 7:
                monthDisplay = "August";
                break;
            case 8:
                monthDisplay = "September";
                break;
            case 9:
                monthDisplay = "October";
                break;
            case 10:
                monthDisplay = "November";
                break;
            case 11:
                monthDisplay = "December";
                break;
            default:
                monthDisplay = "January";
                break;
        }

        this.dateDisplay = dayOfWeekDisplay + ", " + currentDate.getDate() + " " + monthDisplay + " " + currentDate.getFullYear();
    },
    mounted(){
        this.getGroups()
    },
    methods: {
        goTutorial(){
            window.open("https://www.studentqr.com/resources", '_blank');
        },
        getHelp(){            
            window.open("https://helpstudentqr.wasap.my", '_blank');
        },
        viewGroupDashboard(id,name){

            this.$store.commit('UPDATE_VIEW_GROUP_ID',id)
            this.$store.commit('UPDATE_VIEW_GROUP_NAME',name)

            localStorage.setItem('VIEW_GROUP_ID',id)
            localStorage.setItem('VIEW_GROUP_NAME',name)

            this.$router.push({
                name: "GroupDashboardSingle"
            });
        },
        getGroups(){
            //imin ni buat load dari cache gak
            let self = this;
            this.isLoading = true;
            console.log("183 entering getTotalPoints")
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/group/dashboard/all', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        actionYear: self.actionYear
                    }
                })
                .then(response => {
                    self.groupList = response.data.groupList
                    self.isLoading = false
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading = false
                })
        }, 
        goDbGroup() {
            this.$router.push({
                name: "DbGroupMain"
            });
        },
        goGroupLeaderboard() {
            this.$router.push({
                name: "GroupLeaderboard"
            });
        },
    }
};
</script>

<style scoped>
.kelas-button{
    margin-right: 10px;
    margin-bottom: 10px;
}
.header-tag{
    float: right !important;
    border: 1px solid #209cee;
    color: #209cee;
    padding-bottom: calc(0.375em - 1px);
    padding-left: 0.75em;
    padding-right: 0.75em;
    padding-top: calc(0.375em - 1px);
    align-items: center;
    border-radius: 4px;
    font-size: 1rem;
    height: 2.25em;
    line-height: 1.5;
    margin: 10px;
}
.header-date{
    float: right;
    padding: 10px;
}
.attendance-pie{
    width: 250px;
    height: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/Group/Dashboard.vue